import generateImagePreview from '../../../utils/generateImagePreview';
import { actions as imageViewerActions } from '../../ui/imageViewer';

async function previewImage(blob, dispatch) {
  const fixedBlob = await generateImagePreview(blob, true);

  dispatch(
    imageViewerActions.openViewer({
      src: window.URL.createObjectURL(fixedBlob),
    }),
  );
}

export default previewImage;



// WEBPACK FOOTER //
// ./src/redux/chatConnection/helpers/previewImage.js